var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetSchdule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 87.8887C26.6586 87.8887 8.75 69.9799 8.75 47.8887C8.75 25.7973 26.6586 7.88867 48.75 7.88867C70.8412 7.88867 88.75 25.7973 88.75 47.8887C88.75 69.9799 70.8412 87.8887 48.75 87.8887ZM44.75 59.8887V67.8887H52.75V59.8887H44.75ZM44.75 27.8887V51.8887H52.75V27.8887H44.75Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetSchdule);
export default __webpack_public_path__ + "static/media/resetSchdule.23554a914a8385a38ea242071483a19b.svg";
export { ForwardRef as ReactComponent };